import React from 'react';

import Header from '../components/Header.js';
import XO from '../components/ui/XO.js';
import Footer from '../components/ui/Footer.js';

const DefaultLayout = ({ children }) => (
  <div>
    <Header />
    <XO />
    {children}
    <Footer />
  </div>
);

export default DefaultLayout;



// WEBPACK FOOTER //
// ./src/layouts/DefaultLayout.js